import { useRef, useState, useEffect } from "react";

export default function useHover() {
  const [value, setValue] = useState(false);

  const ref = useRef(null);

  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);
  useEffect(
    () => {
      let touchTimeout = null;
      const handleTouchStart = () => {
        if (touchTimeout) clearTimeout(touchTimeout);
        setValue(true);
      };
      const handleTouchEnd = () => {
        if (touchTimeout) clearTimeout(touchTimeout);

        touchTimeout = setTimeout(() => {
          setValue(false);
        }, 2000);
      };
      const node = ref.current;
      if (node) {
        node.addEventListener("mouseover", handleMouseOver);
        node.addEventListener("mouseout", handleMouseOut);
        node.addEventListener("touchstart", handleTouchStart);
        node.addEventListener("touchend", handleTouchEnd);

        return () => {
          if (touchTimeout) clearTimeout(touchTimeout);
          node.removeEventListener("mouseover", handleMouseOver);
          node.removeEventListener("mouseout", handleMouseOut);
          node.removeEventListener("touchstart", handleTouchStart);
          node.removeEventListener("touchend", handleTouchEnd);
        };
      }
    },
    [ref] // Recall only if ref changes
  );

  return [ref, value];
}
